import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const ApproveAccess = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [userData, setUserData] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  useEffect(() => {
    console.log("Extracted ID from URL:", id);
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/auth/users/${id}/`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const responseData = await response.json();
        const data = responseData.data || responseData; // Ensure correct data extraction
        console.log("Fetched user data:", data);
        setUserData({
          email: data.email || "N/A",
          user_type: data.user_type || "N/A",
        });
      } catch (error) {
        setMessage("Failed to fetch user data.");
      } finally {
        setUserLoading(false);
      }
    };
    if (id) fetchUserData();
  }, [id]);

  const handleApprove = async () => {
    setLoading(true);
    setMessage("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/auth/approve-access/${id}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();

      if (!result.is_success && result.message) {
        setMessage(result.message);
      } else {
        setMessage("User access approved successfully.");
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card p-4 shadow-lg rounded-lg"
        style={{
          maxWidth: "400px",
          width: "100%",
          backgroundColor: "#ffffff",
          border: "none",
        }}
      >
        <div className="text-center mb-3">
          <i className="fa fa-user-shield fa-3x text-primary"></i>
        </div>
        <h3 className="text-center text-dark">Approve User Access</h3>
        {userData ? (
          <p className="text-center text-muted">
            Approving access for <strong>{userData.email}</strong>
            <br />
            <span>
              ( User Type: <strong>{userData.user_type}</strong> )
            </span>
          </p>
        ) : (
          <p className="text-center text-muted">Loading user details...</p>
        )}
        {message && (
          <div className="alert alert-info text-center">{message}</div>
        )}
        <button
          className="btn btn-primary w-100 py-2 mt-3 rounded-pill shadow-sm fw-bold"
          onClick={handleApprove}
          disabled={loading}
        >
          {loading ? (
            <>
              <i className="fa fa-spinner fa-spin me-2"></i>Processing...
            </>
          ) : (
            <>
              <i className="fa fa-check-circle me-2"></i>Approve Access
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ApproveAccess;
